import { useMembership } from './useMembership';

export const useIsKaeuferPlusDekra = () => {
  const { realEstateProofRequestedAt, realEstateDamageReportRequestedAt } = useMembership();
  return {
    isRealEstateProofRequested: !!realEstateProofRequestedAt,
    isRealEstateDamageReportRequested: !!realEstateDamageReportRequestedAt,
  };
};
